var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"t-tab-navigation"},_vm._l((_vm.links),function(link){return _c('nuxt-link',{key:link.text,staticClass:"tab",attrs:{"to":link.link}},[_vm._v("\n    "+_vm._s(link.text)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }